// extracted by mini-css-extract-plugin
export default {"container":"ProductAddonGroups_container__GhuNl","addonContainer":"ProductAddonGroups_addonContainer__k3x5f"};